// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;

/*
render function
*/
import { renderCustomCommands } from 'js/customCommandsService';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/customCommandsService', () => import('js/customCommandsService'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "extensionssrc": {
      "type": "string"
    }
  },
  "lifecycleHooks": {
    "render": "render"
  },
  "actions": {
    "render": {
      "deps": "js/customCommandsService",
      "method": "renderCustomCommands"
    }
  },
  "data": {},
  "onEvent": [],
  "i18n": {},
  "_viewModelId": "CustomCommands",
  "_uniqueViewModelId": "CustomCommands",
  "ctx": {}
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderCustomCommands, undefined, ctxImportObj);
export default Component;